import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import ServiceDetails from './pages/ServiceDetails';
import Privacy from './pages/Privacy';
import CookieConsent from './components/CookieConsent/CookieConsent';
import {
  trackPageView,
  initScrollTracking,
  initTimeTracking,
  hasTrackingConsent,
} from './utils/yandexMetrika';

function App() {
  const location = useLocation();

  useEffect(() => {
    // Не трекаем ничего, пока пользователь не дал согласие
    if (!hasTrackingConsent()) return;

    // Отслеживаем изменение страницы
    trackPageView(location.pathname + location.search, {
      title: document.title,
      referer: document.referrer
    });

    // Инициализируем отслеживание только на главной странице
    if (location.pathname === '/') {
      initScrollTracking();
      initTimeTracking();
    }
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/service/:serviceId" element={<ServiceDetails />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      <CookieConsent />
    </>
  );
}

export default App;